import { render } from "./categorias-list.vue?vue&type=template&id=49a0adfe&scoped=true"
import script from "./categorias-list.vue?vue&type=script&lang=js"
export * from "./categorias-list.vue?vue&type=script&lang=js"

import "./categorias-list.vue?vue&type=style&index=0&id=49a0adfe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a0adfe"]])

export default __exports__